export const ALLOWED_NON_TOKEN_COLORS = ['currentColor', 'transparent'];
